import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import RecordPager from "MODULES/shared/components/RecordPager";
import { shortDate } from "LIB/formatters/date";
import DropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Modal, Close, Header } from "MODULES/shared/components/Modal";
import { WAREHOUSE, QUALITY_CONTROL } from "MODULES/users/constants";
import Forbidden from "MODULES/shared/components/Authorized/Forbidden";
import Authorized from "MODULES/shared/components/Authorized/Authorized";
import { CODE, CREATED_AT, REFERENCE_NUMBER } from "APP_ROOT/constants";
import { QC_STATUS } from "MODULES/inventories/constants";
import Form from "./EditQCStatus/Form";
import StatusTags from "../components/shared/StatusTags";
import { CONSIGNMENT_REFERENCE, QC_HOLD, UNDER_REVIEW } from "../constants";
import Unreceive from "./Unreceive/Unreceive";
import ForgiveDemerit from "./ForgiveDemerit";
import * as actions from "../actions";

class HeaderBar extends React.Component {
  state = {
    modalOpen: false
  };

  onConfirmToForgiveDemeritClick = () => {
    const { dispatch } = this.props;

    dispatch(actions.update({ demerit: false }));
  };

  toggleQCModal = () => this.setState({ modalOpen: !this.state.modalOpen });

  render() {
    const { receivingRecord } = this.props;
    const { modalOpen } = this.state;
    const status = {
      qc_status: receivingRecord.getIn(["inventories", 0, QC_STATUS])
    };
    const underReview = receivingRecord
      .toJS()
      .inventories.some(i => i.qc_status === UNDER_REVIEW);
    const hasDiscrepancies = !receivingRecord.get("discrepancies_resolved");
    const referenceNumber = receivingRecord.get(REFERENCE_NUMBER);

    return (
      <div className="page-header page-header-bar">
        <h1>
          <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
            <DropDown
              menuClass="dropdown-menu-right"
              style={{ cursor: "pointer" }}
            >
              <Forbidden roles={[WAREHOUSE]}>
                {receivingRecord.get("reference_record_line_item_type") !==
                  "ManagedRepairOrderLineItem" && (
                  <DropDownItem onClick={this.toggleQCModal}>
                    <i className="fa fa-fw fa-pause-circle" />
                    &nbsp;Update QC Status
                  </DropDownItem>
                )}
              </Forbidden>
              <Unreceive receivingRecord={receivingRecord} />
              <Authorized roles={[QUALITY_CONTROL]}>
                <ForgiveDemerit
                  receivingRecord={receivingRecord}
                  onConfirm={this.onConfirmToForgiveDemeritClick}
                />
              </Authorized>
            </DropDown>
          </div>
          <div className="with-padding">
            <RecordPager baseUrl="/receiving" record={receivingRecord} />
            <span className="header-content">{receivingRecord.get(CODE)}</span>
            <span className="small text-muted">
              Received: {shortDate(receivingRecord.get(CREATED_AT))}
            </span>
            <div className="status-tags alert-group pull-right">
              <StatusTags
                hold={status.qc_status === QC_HOLD}
                discrepancies={hasDiscrepancies}
                underReview={underReview}
              />
            </div>
          </div>
        </h1>
        <Modal
          open={modalOpen}
          close={this.toggleQCModal}
          dialogClass="modal-sm"
        >
          <Header>
            <Close close={this.toggleQCModal} />
            <h4 className="modal-title">Update QC Status</h4>
          </Header>
          <Form
            close={this.toggleQCModal}
            initialValues={status}
            receivingRecord={receivingRecord.toJS()}
            consignmentReference={receivingRecord.get(CONSIGNMENT_REFERENCE)}
            referenceNumber={referenceNumber}
          />
        </Modal>
      </div>
    );
  }
}

HeaderBar.propTypes = {
  receivingRecord: PropTypes.instanceOf(Map).isRequired,
  dispatch: PropTypes.func.isRequired
};

export default connect()(HeaderBar);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Header.jsx